import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"hide-details":"","dense":"","outlined":"","label":"Airport","items":_vm.items,"multiple":false},model:{value:(_vm.airport),callback:function ($$v) {_vm.airport=$$v},expression:"airport"}})
}
var staticRenderFns = []

export { render, staticRenderFns }